// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"42205334","455":"7265dce8","977":"caa0839e"}[chunkId] + ".chunk.js";
};